import { render } from "./Login.vue?vue&type=template&id=19796f15"
import script from "./Login.vue?vue&type=script&lang=js"
export * from "./Login.vue?vue&type=script&lang=js"

import "./Login.vue?vue&type=style&index=0&id=19796f15&lang=css"

import exportComponent from "/home/ubuntu/apps/synergy-login/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__